<template>
        <!-- 账单明细列表 -->
        <el-table :key="0" :data="list" stripe v-loading="loading" :element-loading-text="loadingText" border
                    fit highlight-current-row class="w-100">
            <!-- 保/批单号 -->
            <el-table-column align="left" label="保单号" >
            <template slot-scope="scope">
                <!-- <span v-if="$perm(['company.view_insurance_company'])" class="text-link"
                    @click="handleUpdate(scope.row.id)">{{scope.row.policy_number}}</span> -->
                <span >{{scope.row.policy_number}}</span>
            </template>
            </el-table-column>

            <!-- 含税手续费-->
            <el-table-column align="left" label="含税手续费" >
            <template slot-scope="scope">
                <span>{{ scope.row.commission | parsecurrency }}</span>
            </template>
            </el-table-column>

            <!-- 费率 -->
            <el-table-column align="left" label="费率" >
            <template slot-scope="scope">
                <span>{{ scope.row.commission_rate}}</span>
            </template>
            </el-table-column>

            <!-- 含税保费 -->
            <el-table-column align="left" label="含税保费" width="100px">
            <template slot-scope="scope">
                <span>{{ scope.row.premium | parsecurrency }}</span>
            </template>
            </el-table-column>

            <!-- 不含税保费 -->
            <el-table-column align="left" label="不含税保费" width="120px">
            <template slot-scope="scope">
                <span>{{ scope.row.tax_free_premium | parsecurrency }}</span>
            </template>
            </el-table-column>

            <!-- 险种名称 -->
            <el-table-column align="left" label="险种名称" width="180px">
            <template slot-scope="scope">
                <span>{{ scope.row.insruance_type }}</span>
            </template>
            </el-table-column>

            <!-- 支付对象名称 -->
            <el-table-column align="left" label="支付对象名称" >
            <template slot-scope="scope">
                <span>{{ scope.row.commission_receiver}}</span>
            </template>
            </el-table-column>


            <el-table-column align="left" label="被保险人" >
            <template slot-scope="scope">
                <span>{{scope.row.insured}}</span>
            </template>
            </el-table-column>

            <el-table-column align="left" label="签单日期" >
            <template slot-scope="scope">
                <span>{{scope.row.signing_date | parseTime('{y}年{m}月{d}日') }}</span>
            </template>
            </el-table-column>

            <el-table-column align="left" label="起保日期" >
            <template slot-scope="scope">
                <span>{{scope.row.effective_date | parseTime('{y}年{m}月{d}日') }}</span>
            </template>
            </el-table-column>

        </el-table>
</template>

<script>
import { formatCurrency } from '@/utils/misc'
export default {
    name: 'billing-record-list-tian-an-qing-yuan',
    components: {
    },
    filters: {
      parsecurrency: function(value){
        let v = parseFloat(value).toFixed(4)
        return formatCurrency(v, 2)
      },
    },
    props: [
        'list',
        'loading',
        'loadingText'
    ]
}
</script>
<style lang="scss">

</style>
